import { Button } from '@/components/originui/button';
import { useMemberships } from '@/features/memberships/api/list-memberships';
import { useRevokeSessionMutation } from '@/hooks/auth/mutations/use-revoke-session.mutation';
import { useSwitchAuthContextMutation } from '@/hooks/auth/mutations/use-switch-auth-context.mutation';
import { useAuth } from '@/hooks/auth/use-auth';
import { Spinner } from '@/shared/components/spinner';
import { CircleXIcon } from 'lucide-react';

export function ContextPage() {
  const { context } = useAuth();
  const { isPending, error, data: memberships } = useMemberships({ params: { userId: 'context', include: ['group'] } });
  const mutation = useRevokeSessionMutation();
  const switchContext = useSwitchAuthContextMutation();

  if (isPending) {
    return (
      <div className="mx-auto">
        <Spinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="mx-auto flex flex-col items-center gap-4">
        <CircleXIcon color="red" size={40} />
        {error?.message ?? 'Ett oväntat fel inträffade, försök igen senare.'}
      </div>
    );
  }

  return (
    <div className="mx-auto flex flex-col items-center gap-4">
      {Boolean(memberships.length) ? (
        <>
          <h3 className="text-lg leading-relaxed font-semibold">Välj grupp</h3>
          {memberships.map((m) => (
            <Button
              variant={'ghost'}
              onClick={() => switchContext.mutate(m.groupId)}
              key={m.id}
              disabled={context?.groupId === m.groupId}
            >
              {m.group?.name}
            </Button>
          ))}
        </>
      ) : (
        <>
          <h3 className="text-lg leading-relaxed font-semibold">Du är inte medlem i en grupp</h3>
          <Button variant={'outline'} onClick={() => mutation.mutate()}>
            Logga ut
          </Button>
        </>
      )}
    </div>
  );
}
